exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "cookie-policy {\n  display: block;\n  margin-bottom: 20px;\n}\ncookie-policy table {\n  width: 100%;\n  margin-top: 20px;\n  font-size: 12px;\n}\ncookie-policy table thead tr th {\n  font-weight: 600;\n  text-align: left;\n  white-space: nowrap;\n  background-color: #f3f3f3;\n  padding: 5px 10px;\n}\ncookie-policy table tbody tr td {\n  border-bottom: 1px solid #ddd;\n  padding: 5px 10px;\n}", ""]);

// exports
